import { Controller } from "stimulus";
import {withInputStepperField, withInputStepperFieldTargets} from "mixins/withInputStepperField";

export default class extends withInputStepperField(Controller) {
    static targets = [...withInputStepperFieldTargets];
}
